module.exports = __webpack_public_path__ + "img/luxura_x5.min.b13e8f98.svg";